<template>
  <div class="oaid-checker">
      <div class="py-3"></div>
      <a :href="linktofinder" class="button-primary blue-transparent">
        <span v-text="buttontext"></span>
        <i class="fad fa-arrow-right"></i>
      </a>
  </div>
</template>

<script>
export default {
    props: {
        buttontext: String,
        linktofinder: String
    },
}
</script>
